import React, { Component } from 'react';
import Select from 'react-select';
import { Button } from 'carbon-components-react';
import { toast } from 'react-toastify';
import StepCard from '../../StepCard';
import { listaCamisetas, listaAgasalhos } from '../../../redux/data/fluxoUniformesTrade';
import { updateDmService } from '../../../services/Api';

class DataUniform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataRequest: {
        tamanhoCamiseta: null,
        tamanhoCamiseta2: null,
        tamanhoCamiseta3: null,
        tamanhoAgasalho: null,
      },
      isFinished: false,
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({nivel});
    this.loadSelecteds();
  }

  checksSelecteds = (label) => {
    const item = listaCamisetas.find((camiseta) => {
      if (camiseta.label === label) {
        return camiseta;
      }
      return undefined;
    });

    return item;
  };

  checksSelectedAgasalho = (label) => {
    const item = listaAgasalhos.find((agasalho) => {
      if (agasalho.label === label) {
        return agasalho;
      }
      return undefined;
    });

    return item;
  };

  loadSelecteds = () => {
    const { data } = this.props;
    const uniformes = data.itensAssistente[0] || [];

    // c = camiseta , ag = agasalho
    // verifico se existe trocas no kit para passar o tamanho correto para o select,
    // pois sempre vai existir camiseta 1 2 3 e agasalho, porém somente quando há
    // troca se tem camisetaTroca 1 2 3 e agasalhotroca

    const c1 = data.tipo !== 'Novo' ? uniformes.tamanhoCamisetaTroca : uniformes.tamanhoCamiseta;
    const c2 = data.tipo !== 'Novo' ? uniformes.tamanhoCamisetaTroca2 : uniformes.tamanhoCamiseta2;
    const c3 = data.tipo !== 'Novo' ? uniformes.tamanhoCamisetaTroca3 : uniformes.tamanhoCamiseta3;
    const ag = data.tipo !== 'Novo' ? uniformes.tamanhoAgasalhoTroca : uniformes.tamanhoAgasalho;

    const camiseta1 = this.checksSelecteds(c1);
    const camiseta2 = this.checksSelecteds(c2);
    const camiseta3 = this.checksSelecteds(c3);
    const agasalho = this.checksSelectedAgasalho(ag);

    this.setState({
      dataRequest: {
        tamanhoCamiseta: camiseta1,
        tamanhoCamiseta2: camiseta2,
        tamanhoCamiseta3: camiseta3,
        tamanhoAgasalho: agasalho,
      },
    });
  };

  update = () => {
    const { data } = this.props;
    const { dataRequest } = this.state;

    let formData;
    const item = data.itensAssistente[0];

    if (data.tipo === 'Novo') {
      formData = {
        tamanhoCamiseta: dataRequest.tamanhoCamiseta.value,
        tamanhoCamiseta2: dataRequest.tamanhoCamiseta2.value,
        tamanhoCamiseta3: dataRequest.tamanhoCamiseta3.value,
        tamanhoAgasalho: dataRequest.tamanhoAgasalho.value,
      };
    } else {
      formData = {
        tamanhoCamisetaTroca: dataRequest.tamanhoCamiseta.value,
        tamanhoCamisetaTroca2: dataRequest.tamanhoCamiseta2.value,
        tamanhoCamisetaTroca3: dataRequest.tamanhoCamiseta3.value,
        tamanhoAgasalhoTroca: dataRequest.tamanhoAgasalho.value,
      };
    }

    updateDmService('/Pedido/EditaAssistente', item.id, formData)
      .then(() => {
        toast.success('Atualização realizada com sucesso');
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar atualizar o dado de atendente.');
      });
  };

  cancel = () => {
    this.stepCardRef.toggleContent();
  };

  selectedUniform(obj, id) {
    this.setState(prevState => ({
      ...prevState,
      dataRequest: {
        ...prevState.dataRequest,
        [id]: obj,
      },
    }));
  }

  renderComponent = (data) => {
    const kit = data.itensAssistente[0] || [];
    return (
      <div>
        {kit.tamanhoCamiseta
          && !kit.tamanhoCamisetaTroca && (
            <p>
              <strong>Camiseta #1</strong>
              {' '}
              {kit.tamanhoCamiseta}
            </p>
        )}
        {kit.tamanhoCamisetaTroca && (
          <p>
            <strong>Camiseta #1</strong>
            {' '}
            {kit.tamanhoCamiseta}
          </p>
        )}
        {kit.tamanhoCamiseta2
          && !kit.tamanhoCamisetaTroca2 && (
            <p>
              <strong>Camiseta #2</strong>
              {' '}
              {kit.tamanhoCamiseta2}
            </p>
        )}
        {kit.tamanhoCamisetaTroca2 && (
          <p>
            <strong>Camiseta #2</strong>
            {' '}
            {kit.tamanhoCamisetaTroca2}
          </p>
        )}
        {kit.tamanhoCamiseta3
          && !kit.tamanhoCamisetaTroca3 && (
            <p>
              <strong>Camiseta #3</strong>
              {' '}
              {kit.tamanhoCamiseta3}
            </p>
        )}
        {kit.tamanhoCamisetaTroca3 && (
          <p>
            <strong>Camiseta #3</strong>
            {' '}
            {kit.tamanhoCamisetaTroca3}
          </p>
        )}
        {kit.tamanhoAgasalho
          && !kit.tamanhoAgasalhoTroca && (
            <p>
              <strong>Agasalho</strong>
              {' '}
              {kit.tamanhoAgasalho}
            </p>
        )}
        {kit.tamanhoAgasalhoTroca && (
          <p>
            <strong>Agasalho</strong>
            {' '}
            {kit.tamanhoAgasalhoTroca}
          </p>
        )}
        {kit.motivoTroca && (
          <p>
            <strong>Motivo da troca: </strong>
            {kit.motivoTroca}
          </p>
        )}
      </div>
    );
  };

  render() {
    const { data } = this.props;
    const { dataRequest, nivel } = this.state;

    return (
      <StepCard
        onRef={(ref) => {
          this.stepCardRef = ref;
        }}
        title="Uniforme"
        description={this.renderComponent(data)}
        isFinished
      >
        <div className="bx--row">
          <div className="bx--col-md-6">
            <label>Camiseta #1</label>
            {' '}
            <br />
            <Select
              value={dataRequest.tamanhoCamiseta}
              label="Digite o nome do atendente."
              placeholder="Tamanho"
              options={listaCamisetas}
              onChange={e => this.selectedUniform(e, 'tamanhoCamiseta')}
              className="search-dm select-dm"
            />
          </div>
        </div>
        <br />
        <div className="bx--row">
          <div className="bx--col-md-6">
            <label>Camiseta #2</label>
            {' '}
            <br />
            <Select
              value={dataRequest.tamanhoCamiseta2}
              label="Digite o nome do atendente."
              placeholder="Tamanho"
              options={listaCamisetas}
              onChange={e => this.selectedUniform(e, 'tamanhoCamiseta2')}
              className="search-dm select-dm"
            />
          </div>
        </div>
        <br />
        <div className="bx--row">
          <div className="bx--col-md-6">
            <label>Camiseta #3</label>
            {' '}
            <br />
            <Select
              value={dataRequest.tamanhoCamiseta3}
              label="Digite o nome do atendente."
              placeholder="Tamanho"
              options={listaCamisetas}
              onChange={e => this.selectedUniform(e, 'tamanhoCamiseta3')}
              className="search-dm select-dm"
            />
          </div>
        </div>
        <br />
        <div className="bx--row">
          <div className="bx--col-md-6">
            <label>Agasalho</label>
            {' '}
            <br />
            <Select
              value={dataRequest.tamanhoAgasalho}
              label="Digite o nome do atendente."
              placeholder="Tamanho"
              options={listaAgasalhos}
              onChange={e => this.selectedUniform(e, 'tamanhoAgasalho')}
              className="search-dm select-dm"
            />
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-md-12">
            <br />
            {' '}
            <br />
            <div className="v-md-margin mg-top-40">

              {nivel === 10 && (<Button onClick={this.update}>Salvar</Button>)}
              <Button kind="ghost" className="h-sm-margin" onClick={this.cancel}>
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </StepCard>
    );
  }
}

export default DataUniform;



// WEBPACK FOOTER //
// ./src/components/trades/uniforms/DataUniform.js